"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Localize_1 = require("../../gen-src/Localize");
var metrics_engine_1 = require("@tableau/metrics-engine");
function formatRefreshedSince(date) {
    var fromDate = Localize_1.Formatters.formatLongBestFitRelativeTime(date);
    return Localize_1.Messages.refreshedSince({ fromDate: fromDate });
}
exports.formatRefreshedSince = formatRefreshedSince;
function formatLastUpdatedDate(date) {
    var day = Localize_1.Formatters.wordyDate(date);
    var time = Localize_1.Formatters.timeToMinutes(date);
    return Localize_1.Messages.syncedAtTime({ day: day, time: time });
}
exports.formatLastUpdatedDate = formatLastUpdatedDate;
function formatDataPointAsMetricNumber(value, formatString) {
    return metrics_engine_1.formatValueAsMetricNumber(value !== undefined ? value.measure : undefined, formatString);
}
exports.formatDataPointAsMetricNumber = formatDataPointAsMetricNumber;
//# sourceMappingURL=formatting.js.map